<template>
  <v-container class="my-documents-container standard-content-container">
    <div v-if="!loading && testator">
      <v-row no-gutters>
        <v-col cols="12" md="5">
          <v-row no-gutters class="title-section">
            <v-col
              cols="12"
              sm="2"
              class="link-container"
              :class="{
                'small-container':
                  $vuetify.breakpoint.width <=
                  $vuetify.breakpoint.thresholds.xs,
              }"
            >
              <router-link :to="{ name: 'OverviewPage' }" class="back-arrow">
                <v-icon large color="mid-grey" class="mt-1">{{
                  icons.mdiArrowLeft
                }}</v-icon>
              </router-link>
            </v-col>
            <v-col cols="12" sm="10" class="standard-title-container">
              <h1>Document Vault</h1>
              <p class="my-documents-description">
                Keep your important documents in one place so your executor and
                family can find them when they're needed.
              </p>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12" md="7" class="mt-4">
          <div class="left-section-container">
            <DocumentCategorySection
              v-for="group in groupedCategories"
              :key="group.name"
              :viewed-testator-id="testator.id"
              :name="group.name"
              :entries="group.entries"
              @refetch="refetch"
              @deleted="onDocumentDeleted"
            />
          </div>
        </v-col>
      </v-row>

      <ErrorSnackbar v-model="showError" :error="errorMessage" />
    </div>

    <div v-else class="text-center mt-12">
      <v-progress-circular indeterminate color="primary" />
    </div>
  </v-container>
</template>

<script>
  import { mdiArrowLeft } from '@mdi/js';
  import { TESTATOR_QUERY } from '../../constants/graphql/testators';
  import { groupDocumentsByCategory } from '../../constants/js/testator-documents';
  import DocumentCategorySection from './DocumentCategorySection.vue';
  import ErrorSnackbar from '../common/ErrorSnackbar.vue';

  export default {
    name: 'MyDocuments',
    components: {
      DocumentCategorySection,
      ErrorSnackbar,
    },
    data() {
      return {
        icons: { mdiArrowLeft },
        testator: null,
        loading: true,
        showError: false,
        errorMessage: null,
      };
    },
    apollo: {
      testator: {
        query: TESTATOR_QUERY,
        variables() {
          return { id: this.$store.getters.testatorId };
        },
        skip() {
          return !this.$store.getters.testatorId;
        },
        result() {
          this.loading = false;
        },
        error() {
          this.loading = false;
        },
      },
    },
    computed: {
      groupedCategories() {
        if (!this.testator) return [];
        return groupDocumentsByCategory(
          this.testator.testatorDocumentCategories || [],
          this.testator.testatorDocuments || []
        );
      },
    },
    methods: {
      async refetch() {
        await this.$apollo.queries.testator.refetch();
      },
      onDocumentDeleted() {
        this.refetch();
      },
    },
  };
</script>

<style scoped lang="scss">
  .my-documents-container {
    text-align: left;
    padding-top: 40px;
    padding-bottom: 40px;

    .standard-title-container {
      .my-documents-description {
        font-size: 16px;
        font-weight: 400;
        line-height: 22px;
        color: #282828;
        padding-top: 20px;
      }
    }
  }
</style>
